// @ts-nocheck
import { TrackPowerBiEventsParameters } from "@store/Framework/GoogleAnalytics/trackers/trackPowerBi";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const useTrackPowerBi = (parameters: TrackPowerBiEventsParameters = {}, options?: Toolkit.GoogleAnalytics.Options) =>
    ga.util.getEventTrackerHook(ga.track.trackPowerBi, parameters, options);

export default useTrackPowerBi;
